import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, LogIn, Building } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  
  // --- 1. LÓGICA DE DETECCIÓN DE SUBDOMINIO ---
// --- 1. LÓGICA DE DETECCIÓN DE SUBDOMINIO (B2B) ---
  const hostName = window.location.hostname; 
  // Ejemplos de lo que detectará:
  // "edu.emdingenieros.com" -> 3 partes (SuperAdmin)
  // "sanjuan.edu.emdingenieros.com" -> 4 partes (Colegio)
  
  const hostParts = hostName.split('.');
  
  // Es un colegio SOLAMENTE si tiene 4 partes y la segunda es "edu"
  const esSubdominio = hostName !== 'localhost' && hostParts.length >= 4 && hostParts[1] === 'edu';
  
  // Si es colegio, el alias es la primera palabra (ej. "sanjuan"). Si no, lo dejamos vacío.
  const aliasDetectado = esSubdominio ? hostParts[0] : '';
  // --------------------------------------------
  // --------------------------------------------

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [aliasColegio, setAliasColegio] = useState(aliasDetectado); // Se autocompleta si hay subdominio
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // Enviamos el alias junto con el correo y clave
        body: JSON.stringify({ 
          email: email.trim(), 
          password: password, 
          aliasColegio: aliasColegio.trim() 
        })
      });

      if (!response.ok) {
        // Capturamos el mensaje de error real que envía C# (ej. "Credenciales incorrectas")
        const errorText = await response.text();
        throw new Error(errorText || 'Error de conexión');
      }

      const data = await response.text();
      
      localStorage.setItem('token', data);
      navigate('/dashboard'); 
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        
        <div className="bg-blue-600 p-8 text-center relative">
          <h1 className="text-3xl font-bold text-white mb-2">EduControl</h1>
          <p className="text-blue-100 text-sm">EMD Ingeniería y Tecnología</p>
        </div>

        <div className="p-8 pt-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2 text-center">
            Iniciar Sesión
          </h2>

          {/* ETIQUETA INTELIGENTE: Si detecta subdominio, lo muestra elegante */}
          {esSubdominio && (
            <div className="flex justify-center mb-6">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-blue-50 text-blue-700 border border-blue-100">
                <Building size={14} />
                Ingresando a: {aliasColegio.toUpperCase()}
              </span>
            </div>
          )}

          {!esSubdominio && <div className="mb-6"></div>}

          {error && (
            <div className="bg-red-50 text-red-600 p-3 rounded-lg mb-6 text-sm text-center border border-red-200 font-medium">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-5">
            
            {/* CAMPO DE ALIAS: Solo se muestra si NO estamos en un subdominio */}
            {!esSubdominio && (
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">
                  Código de Institución (Opcional)
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Building className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-gray-50"
                    placeholder="Ej: colegioA (Vacío si es EMD)"
                    value={aliasColegio}
                    onChange={(e) => setAliasColegio(e.target.value)}
                  />
                </div>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Correo Electrónico
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="email"
                  required
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="admin@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contraseña
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="password"
                  required
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center items-center gap-2 py-3 px-4 border border-transparent rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors font-medium disabled:opacity-70 mt-4"
            >
              {loading ? 'Verificando...' : (
                <>
                  <LogIn className="h-5 w-5" />
                  Ingresar al Sistema
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;